export const ADD_USER = 'ADD_USER';
export const RECEIVE_USER = 'RECEIVE_USER';
require('dotenv').config();

function receiveUsers(users) {
  return {
    type: RECEIVE_USER,
    users,
  };
}

export function handleReceiveUsers() {
  return dispatch => {
    fetch('https://ptwc3simh7.execute-api.us-east-2.amazonaws.com/Prod')
      .then(users => users.json())
      .then(res => {
        dispatch(receiveUsers(res));
      })
      .catch(e =>
        console.log('Error with getting the users to add it to Redux', e)
      );
  };
}

function saveUser(name, email, password) {
  return {
    type: ADD_USER,
    name,
    email,
    password,
  };
}

export function handleAddUser(name, email, password) {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  return dispatch => {
    fetch('https://qtdva1hyif.execute-api.us-east-2.amazonaws.com/Prod', {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        _id: email,
        name: name,
        email: email,
        password: password,
      }),
    })
      .then(res => {
        dispatch(saveUser(name, email, password));
      })
      .catch(error => {});
  };
}
